import { useState, useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { Checkbox, Autocomplete, CircularProgress, FormControl, FormHelperText, FormLabel, Grid, MenuItem, Select, TextField, ListItemText} from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { useFormik } from 'formik';
import * as yup from "yup";
import { useSelector, useDispatch } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { fetchProjectTypeData } from '../../redux/slice/projectTypeSlice';
import { apipost } from '../../service/api';
import Palette from '../../theme/palette';

const Add = (props) => {
    const { open, handleClose, setUserAction, _id } = props
    const userid = sessionStorage.getItem('user_id')
    const userRole = sessionStorage.getItem("userRole")
    const userDetails = useSelector((state) => state?.userDetails?.data)
    const projectTypeList = useSelector((state) => state?.projectTypeDetails?.data);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch()

    // -----------  validationSchema
    const validationSchema = yup.object({
        projectType: yup.string().required("Project Type is required"),
        projectStartDate: yup.date().required("Project Start Date is required"),
        projectEndDate: yup.date().required("Project End Date is required"),
        projectStatus: yup.string().required("Project Status is required"),
        projectAmounts: yup.number().required("Project Amounts is required"),
        clientName: yup.string().nullable(),
        clientDateOfBirth: yup.date().nullable(),
        phoneNumber: yup.string().matches(/^[0-9]*$/, 'Phone Number is invalid'),
        emailAddress: yup.string().email('Invalid email'),
    });

    // -----------   initialValues
    const initialValues = {
        projectType: "",
        projectStartDate: "",
        projectEndDate: "",
        projectStatus: "",
        projectAmounts: "",
        clientName: "",
        clientDateOfBirth: "",
        phoneNumber: "",
        emailAddress: "",
        projectCost: "",
        Frequency: "",
        feeEarned: "0",
        createdBy: userid,
        contact_id: _id,
        assigned_staff: [],
    };

    // add project api
    const addProject = async (values) => {
        setIsLoading(true);
        try {
            const data = values
            const result = await apipost('api/project/add', data)

            setUserAction(result)

            if (result && result.status === 201) {
                formik.resetForm();
                handleClose();
            }
        } catch (error) {
            console.error('Error adding lead:', error);
        }
        setIsLoading(false);
    }

    // formik
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values) => {
            addProject(values)
        },
    });

    useEffect(() => {
        if (projectTypeList?.length === 0)
            dispatch(fetchProjectTypeData())
    }, [open])
    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle
                    id="scroll-dialog-title"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <Typography variant="h6">Add New </Typography>
                    <Typography>
                        <ClearIcon
                            onClick={handleClose}
                            style={{ cursor: "pointer" }}
                        />
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <form>
                        <DialogContentText
                            id="scroll-dialog-description"
                            tabIndex={-1}
                        >
                            <Typography style={{ marginBottom: "15px" }} variant="h6">
                                Project Details
                            </Typography>
                            <Grid
                                container
                                rowSpacing={3}
                                columnSpacing={{ xs: 0, sm: 5, md: 4 }}
                            >
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth>
                                        <FormLabel>Project Type <span style={{ color: "red" }}>*</span></FormLabel>
                                        <Autocomplete
                                            id="combo-box-demo"
                                            options={projectTypeList}
                                            getOptionLabel={(item) => item?.type_name}
                                            value={projectTypeList?.find((item) => item?.type_name === formik.values.projectType)}
                                            onChange={(event, newValue) => {
                                                formik.setFieldValue("projectType", newValue ? newValue?.type_name : "");
                                                formik.setFieldValue("projectAmounts", newValue ? newValue?.charge : "");
                                            }}
                                            renderInput={(params) =>
                                                <TextField {...params}
                                                    size="small"
                                                    error={formik.touched.projectType && Boolean(formik.errors.projectType)}
                                                    helperText={formik.touched.projectType && formik.errors.projectType}
                                                    placeholder='Select'
                                                />}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormLabel>Project Start Date <span style={{ color: "red" }}>*</span></FormLabel>
                                    <TextField
                                        name='projectStartDate'
                                        type='date'
                                        size='small'
                                        fullWidth
                                        value={formik.values.projectStartDate}
                                        onChange={formik.handleChange}
                                        error={formik.touched.projectStartDate && Boolean(formik.errors.projectStartDate)}
                                        helperText={formik.touched.projectStartDate && formik.errors.projectStartDate}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormLabel>Project End Date <span style={{ color: "red" }}>*</span></FormLabel>
                                    <TextField
                                        name='projectEndDate'
                                        type='date'
                                        size='small'
                                        fullWidth
                                        value={formik.values.projectEndDate}
                                        onChange={formik.handleChange}
                                        error={formik.touched.projectEndDate && Boolean(formik.errors.projectEndDate)}
                                        helperText={formik.touched.projectEndDate && formik.errors.projectEndDate}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth>
                                        <FormLabel>Project Status <span style={{ color: "red" }}>*</span></FormLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="projectStatus"
                                            name="projectStatus"
                                            size='small'
                                            fullWidth
                                            value={formik.values.projectStatus}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched.projectStatus &&
                                                Boolean(formik.errors.projectStatus)
                                            }
                                            helperText={
                                                formik.touched.projectStatus && formik.errors.projectStatus
                                            }
                                        >
                                            <MenuItem value="Active">Active</MenuItem>
                                            <MenuItem value="InActive">InActive </MenuItem>
                                            <MenuItem value="Canceled">Canceled </MenuItem>
                                        </Select>
                                        <FormHelperText style={{ color: Palette.error.main }}>{formik.touched.projectStatus && formik.errors.projectStatus}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Typography
                                style={{ marginBottom: "15px", marginTop: "15px" }}
                                variant="h6"
                            >
                                Project Coverage Details
                            </Typography>
                            <Grid
                                container
                                rowSpacing={3}
                                columnSpacing={{ xs: 0, sm: 5, md: 4 }}
                            >
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormLabel>Project Amounts <span style={{ color: "red" }}>*</span></FormLabel>
                                    <TextField
                                        id="projectAmounts"
                                        name="projectAmounts"
                                        size='small'
                                        type='number'
                                        fullWidth
                                        value={formik.values.projectAmounts}
                                        onChange={formik.handleChange}
                                        error={
                                            formik.touched.projectAmounts &&
                                            Boolean(formik.errors.projectAmounts)
                                        }
                                        helperText={
                                            formik.touched.projectAmounts && formik.errors.projectAmounts
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <Typography
                                style={{ marginBottom: "15px", marginTop: "15px" }}
                                variant="h6"
                            >
                                Client Details
                            </Typography>
                            <Grid
                                container
                                rowSpacing={3}
                                columnSpacing={{ xs: 0, sm: 5, md: 4 }}
                            >
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormLabel>Person Name </FormLabel>
                                    <TextField
                                        name='clientName'
                                        size='small'
                                        fullWidth
                                        value={formik.values.clientName}
                                        onChange={formik.handleChange}
                                        error={formik.touched.clientName && Boolean(formik.errors.clientName)}
                                        helperText={formik.touched.clientName && formik.errors.clientName}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormLabel>Date Of Birth </FormLabel>
                                    <TextField
                                        name='clientDateOfBirth'
                                        type='date'
                                        size='small'
                                        fullWidth
                                        value={formik.values.clientDateOfBirth}
                                        onChange={formik.handleChange}
                                        error={formik.touched.clientDateOfBirth && Boolean(formik.errors.clientDateOfBirth)}
                                        helperText={formik.touched.clientDateOfBirth && formik.errors.clientDateOfBirth}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                <FormControl fullWidth>
                                    <FormLabel>Assigned Staff</FormLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="assigned_staff"
                                        name="assigned_staff"
                                        size="small"
                                        multiple
                                        value={formik.values.assigned_staff}
                                        onChange={formik.handleChange}
                                        error={formik.touched.assigned_staff && Boolean(formik.errors.assigned_staff)}
                                        renderValue={(selected) => (
                                            <div>
                                                {
                                                    selected.map((value) => {
                                                        const userData = userDetails?.find((user) => user._id === value)
                                                        return (
                                                            <div key={value}>
                                                                {`${userData?.firstName} ${userData?.lastName}`}
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        )
                                        }
                                    >
                                        {
                                            userDetails?.map((user) => (
                                                <MenuItem value={user?._id}>
                                                    <Checkbox checked={formik.values.assigned_staff.indexOf(user?._id) > -1} />
                                                    <ListItemText primary={`${user?.firstName} ${user?.lastName}`} />
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                        <FormHelperText
                                            error={
                                                formik.touched.assigned_staff && Boolean(formik.errors.assigned_staff)
                                            }
                                        >
                                        {formik.touched.assigned_staff && formik.errors.assigned_staff}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Typography
                                style={{ marginBottom: "15px", marginTop: "15px" }}
                                variant="h6"
                            >
                                Client's contact information
                            </Typography>
                            <Grid
                                container
                                rowSpacing={3}
                                columnSpacing={{ xs: 0, sm: 5, md: 4 }}
                            >
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormLabel>Phone Number </FormLabel>
                                    <TextField
                                        id=""
                                        name="phoneNumber"
                                        type="number"
                                        size='small'
                                        fullWidth
                                        value={formik.values.phoneNumber}
                                        onChange={formik.handleChange}
                                        error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                                        helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormLabel>Email </FormLabel>
                                    <TextField
                                        id="emailAddress"
                                        name="emailAddress"
                                        type="email"
                                        size='small'
                                        fullWidth
                                        value={formik.values.emailAddress}
                                        onChange={formik.handleChange}
                                        error={formik.touched.emailAddress && Boolean(formik.errors.emailAddress)}
                                        helperText={formik.touched.emailAddress && formik.errors.emailAddress}
                                    />
                                </Grid>
                            </Grid>
                            <Typography
                                style={{ marginBottom: "15px", marginTop: "15px" }}
                                variant="h6"
                            >
                                Project Project Costs and Payments
                            </Typography>
                            <Grid
                                container
                                rowSpacing={3}
                                columnSpacing={{ xs: 0, sm: 5, md: 4 }}
                            >
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormLabel>Project Cost Amount</FormLabel>
                                    <TextField
                                        id="projectCost"
                                        name="projectCost"
                                        type="number"
                                        size='small'
                                        fullWidth
                                        value={formik.values.projectCost}
                                        onChange={formik.handleChange}

                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth>
                                        <FormLabel>Project Cost Payments</FormLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="Frequency"
                                            name="Frequency"
                                            label=""
                                            size='small'
                                            value={formik.values.Frequency}
                                            onChange={formik.handleChange}
                                        >
                                            <MenuItem value="Monthly">Monthly</MenuItem>
                                            <MenuItem value="Annually">Annually </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth>
                                        <FormLabel>feeEarned Earned</FormLabel>
                                        <TextField
                                        id="feeEarned"
                                        name="feeEarned"
                                        type="number"
                                        size='small'
                                        fullWidth
                                        value={formik.values.feeEarned}
                                        onChange={formik.handleChange}/>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </DialogContentText>
                    </form>
                </DialogContent>
                <DialogActions>
                    <LoadingButton onClick={formik.handleSubmit} variant='contained' color='primary' disabled={!!isLoading}>
                        {isLoading ? <CircularProgress size={27} /> : 'Save'}
                    </LoadingButton>
                    <Button onClick={() => {
                        formik.resetForm()
                        handleClose()
                    }} variant='outlined' color='error'>Cancle</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Add